import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 7 — alert_events.type catalogue.
 *
 * Mirrors the alert_events.type CHECK constraint:
 *   t14_missed | t30_missed | creator_at_risk_runrate |
 *   rank_up_eligibility_change | biggest_bonus_gap_morning | other
 *
 * deepLink(payload) returns the route the agent should land on when they
 * tap the alert. It receives the raw payload_json and uses entity_id when
 * relevant. Returns null → no deep-link, just mark-as-read.
 */
export const ALERT_TYPES = [
  {
    id: 't14_missed',
    label: 'T+14 missed',
    icon: 'warn',
    color: TCN.amber,
    severity: 'medium',
    deepLink: () => '/tcn/me/new-creators',
  },
  {
    id: 't30_missed',
    label: 'T+30 missed',
    icon: 'warn',
    color: TCN.red,
    severity: 'high',
    deepLink: () => '/tcn/me/new-creators',
  },
  {
    id: 'creator_at_risk_runrate',
    label: 'Creator at risk',
    icon: 'flame',
    color: TCN.red,
    severity: 'high',
    deepLink: (payload) => payload?.entity_id
      ? `/tcn/me/creators/${payload.entity_id}`
      : '/tcn/me/creators',
  },
  {
    id: 'rank_up_eligibility_change',
    label: 'Rank-up eligibility',
    icon: 'tiers',
    color: TCN.cyan,
    severity: 'low',
    deepLink: (payload) => payload?.entity_id
      ? `/tcn/me/creators/${payload.entity_id}`
      : '/tcn/me/tiers',
  },
  {
    id: 'biggest_bonus_gap_morning',
    label: 'Bonus gap morning',
    icon: 'cash',
    color: TCN.magenta,
    severity: 'medium',
    deepLink: () => '/tcn/me/payout',
  },
  {
    id: 'other',
    label: 'Notification',
    icon: 'bell',
    color: TCN.textDim,
    severity: 'low',
    deepLink: () => null,
  },
];

export const ALERT_TYPE_BY_ID = Object.fromEntries(ALERT_TYPES.map(t => [t.id, t]));

export const SEVERITY_RANK = { high: 3, medium: 2, low: 1 };
